// extracted by mini-css-extract-plugin
export default {"srOnly":"reason-tooltip_srOnly__Aytiw"};